// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1CxHK","header":"ReportDetails_header__1PP__","title":"ReportDetails_title__oJVXq","left":"ReportDetails_left__2iYaD"};